import React from "react";
import { IExperience } from "../interfaces/IExperience";

type Props = IExperience & { isLast?: boolean };

export default function ExperienceItem({ organization, location, totalDuration, roles, isLast }: Props) {
  return (
    <div className="flex gap-3">
      {/* Timeline column: node + connecting line */}
      <div className="flex flex-col items-center shrink-0">
        <div className="w-3 h-3 rounded-full border-2 border-pink-400 bg-[#060e22] shrink-0 mt-1" />
        {!isLast && <div className="w-px flex-1 bg-white/15 my-1" />}
      </div>

      {/* Content column */}
      <div className={`flex-1 min-w-0 ${isLast ? "pb-2" : "pb-5"}`}>
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="text-sm font-semibold text-white">{organization}</h3>
          <span className="text-xs text-gray-500 shrink-0">{totalDuration}</span>
        </div>
        {location && <p className="text-xs text-gray-500 mt-0.5">{location}</p>}

        <div className="flex flex-col gap-3 mt-2">
          {roles.map((r, i) => (
            <div key={i} className="flex gap-2">
              {/* Role dot */}
              <div className="flex flex-col items-center shrink-0 pt-1.5">
                <div className="w-1.5 h-1.5 rounded-full bg-pink-400/50 shrink-0" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline justify-between gap-2">
                  <p className="text-xs font-medium text-gray-200">{r.role}</p>
                  <span className="text-xs text-gray-500 shrink-0">{r.date}</span>
                </div>
                <p className="text-gray-400 text-xs mt-1 leading-relaxed">{r.description}</p>
                <div className="flex flex-wrap mt-1.5 gap-1">
                  {r.technologies.map((tech, j) => (
                    <span key={j} className="bg-blue-800 text-white text-xs font-medium px-2 py-0.5 rounded-full">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
